import { type SxProps } from '@mui/material';

export const TopBarLanguageChangeLanguageIconStyles: SxProps = {
  alignItems: 'center',
  borderRadius: '50%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};
